module.exports = __webpack_public_path__ + "static/img/2_09.be1258c5.jpg";